import React from "../../__compat__/react/main.entry.mjs.mjs";
import { useSpacing } from "../../api/spacing/useSpacing.mjs.mjs";
import { pickAriaProps, pickComponentCommonProps, } from "../../interfaces/commonProps.mjs.mjs";
import { StyledLayoutItem } from "./LayoutItem.styles.mjs.mjs";
export const LayoutItem = React.forwardRef(({ align = 'start', basis = 'auto', children, grow = '0', shrink = '1', role, ...restProps }, ref) => {
    return (React.createElement(StyledLayoutItem, { outerSpacing: useSpacing(restProps), align: align, basis: basis, grow: grow, ref: ref, shrink: shrink, role: role, ...pickComponentCommonProps(restProps), ...pickAriaProps(restProps) }, children));
});
LayoutItem.displayName = 'LayoutItem';
//# sourceMappingURL=LayoutItem.mjs.mjs.map